<div class="block wrapper">
  <div *ngFor="let stack of stacks">
    <div>{{stack.message}}</div>
    <div *ngFor="let element of stack.elements">&nbsp;&nbsp;&nbsp;&nbsp;{{element}}</div>
  </div>
</div>
